export default __webpack_public_path__ + "static/media/BrainBreak cards34.73d60009.png";